import { UserOutlined } from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const UserProfilePage = lazyRouteComponent(() => import('./pages/profile'));

export const getRoutes = (): Route[] => [
  {
    page: UserProfilePage,
    path: ROUTE_PATHS.PROFILE,
    title: 'Perfil',
    icon: UserOutlined,
    hidden: true,
    allowUnverified: true,
  },
];
